import navDataSlice from './navDataSlice';
import dealerInfoReducer from './dealerInfoSlice';

const root = {
	navData: navDataSlice.reducer,
	dealerInfo: dealerInfoReducer
};

export default root;
